import type { AddTaskFormValues } from "@/components/Forms/SubForms/AssignTasksByTemplateForm.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useAddCaseTask = (
    TaskUUID?: string,
): UseMutationResult<void, Error, AddTaskFormValues> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (attributes) => {
            const body = {
                TaskUUID: TaskUUID,
                ...attributes,
            };

            const response = await fetch(apiUrl("/case-task/add-edit"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify(body),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["tasks"],
            });
        },
    });
};
